import { ChangeRequestLogEntryWithId, getChangeRequestsEndpoint } from 'common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-10/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<
    ChangeRequestLogEntryWithId[],
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'changeLogs',
    fetchCallback() {
        return CpDataApi.get(getChangeRequestsEndpoint()).then((response) => response.data);
    },
});

export default reducer;
export const fetchChangeLogs = fetchData;
